import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"search\"><path d=\"M105.6875,439.625 C103.516442,439.625 101.75,437.85873 101.75,435.6875 C101.75,433.51627 103.516442,431.75 105.6875,431.75 C107.858529,431.75 109.625,433.51627 109.625,435.6875 C109.625,437.85873 107.858529,439.625 105.6875,439.625 M105.6875,430 C102.551311,430 100,432.551511 100,435.6875 C100,438.823517 102.551311,441.375 105.6875,441.375 C106.781078,441.375 107.802884,441.064032 108.670878,440.527136 L111.759285,443.615715 C112.007259,443.863517 112.336985,444 112.6875,444 C113.038015,444 113.367569,443.863517 113.615515,443.615715 C113.863489,443.367913 114,443.038015 114,442.687529 C114,442.336985 113.863489,442.007288 113.615515,441.759485 L110.526965,438.670907 C111.064032,437.802913 111.375,436.781078 111.375,435.6875 C111.375,432.551511 108.82366,430 105.6875,430\" transform=\"translate(-100 -430)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/search.svg
// module id = 1741
// module chunks = 0